<div aria-hidden="true" class="tt-offscreen-flowchart-capture">
  @for (item of items(); track item.widgetId) {
    <tt-flowchart
      ttColorCustomisations
      [allowEvents]="false"
      [customisation]="organisationSettings().customisations?.flowchart"
      [flowchartElements]="item.elements"
      [flowchartId]="item.widgetId"
      (paperReady)="handlePaperReady($event)" />
  }
</div>
